<app-abandon-accounts (noContinue)="closePopin()" (yesAbandon)="abandon()" [show]="isPopinOpen"></app-abandon-accounts>

<div class="w-full max-w-600px d-flex flex-col justify-center items-center">
  <span class="text-primary picto-bank-exclamation picto-size-13"></span>
  <!-- FIXME map username -->
  <h1 class="mb-5 mt-1" [innerHTML]="'none_accounts_found_title' | translate : {userName: ''} "></h1>

  <p class="font-md-16 font-bold mb-0"> {{'none_accounts_found_first_paragraph' | translate }}</p>
  <p class="font-md-16" [innerHTML]="'none_accounts_found_second_paragraph' | translate "></p>

  <button (click)="connectToOtherBank()" class="btn bg-primary rounded-full px-10 mt-10">
    {{'connect_to_other_bank_btn' | translate }}
  </button>

  <a (click)="openPopin()" class="text-dark mt-5" role="button">
    {{'none_accounts_found_abandon' | translate }}
  </a>
</div>
